"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _Charts = require("../../Charts");
function getYScaleCreator(dataItems, areAllRealTimeItemUsingSameUnits) {
  if (dataItems.length > 1) {
    return areAllRealTimeItemUsingSameUnits ? (0, _Charts.unitScaleFactory)(dataItems[0].units, _Charts.createLinearScaleWithPadding) : _Charts.createLinearScaleWithPadding;
  }
  return dataItems[0].units ? (0, _Charts.unitScaleFactory)(dataItems[0].units, _Charts.createLinearScale) : _Charts.createLinearScale;
}
var _default = exports["default"] = getYScaleCreator;